<template>
  <div class="footer">
    <div class="footer_n">
      <p>版权所有：中共铁岭县纪律检查委员会</p>
      <p>地址：铁岭市凡河新区金沙江路18号</p>
      <p><a href="http://beian.miit.gov.cn/" target="_blank">辽ICP备16006427号-2</a></p>
      <p class="cms"><img src="../assets/images/batp.png" /><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=21122102000194" target="_blank">辽公网安备 21122102000194号</a></p>
      <img class="ft_l" src="../assets/images/red.png" />
    </div>
  </div>
</template>

<script>
  import "@/assets/css/footer.css";
  export default {
    name: "footers",
    data() {
      return {
      };
    },
    created(){
    },
    methods: {
    },
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/footer.vue